export default {
  aboc: {
    name: 'ABOC',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_ABOC_v2.zip',
  },
  alaska: {
    name: 'Alaska Airlines Mileage Plan™',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_AlaskaAirlinesMileagePlan.zip',
  },
  alliant: {
    name: 'Alliant Credit Union',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_Alliant_v3.zip',
  },
  ally: {
    name: 'Ally',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_Ally_v2.zip',
  },
  amex: {
    name: 'American Express',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_AmEx_v2.zip',
  },
  avant: {
    name: 'Avant',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_Avant_v2.zip',
  },
  axos: {
    name: 'Axos Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_AxosBank_v2.zip',
  },
  bettermortgage: {
    name: 'Better Mortgage',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_BetterMortgage_v2.zip',
  },
  capitalone: {
    name: 'Capital One',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_CapitalOne_v2.zip',
  },
  chasebank: {
    name: 'Chase Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_ChaseBank_v3.zip',
  },
  chasesapphirereserve: {
    name: 'Chase Sapphire Reserve',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_ChaseSapphireReserve_v2.zip',
  },
  cit: {
    name: 'CIT Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_CITBank_v2.zip',
  },
  citi: {
    name: 'Citi',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_Citi_v3.zip',
  },
  collegeave: {
    name: 'College Ave',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_CollegeAve_v3.zip',
  },
  commonbond: {
    name: 'CommonBond',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_CommonBond_v2.zip',
  },
  deserveedu: {
    name: 'Deserve Edu',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_DeserveEdu_v3.zip',
  },
  discoverbank: {
    name: 'Discover Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_DiscoverBank_v3.zip',
  },
  discovercards: {
    name: 'Discover Cards',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_Discoverit_v3.zip',
  },
  earnest: {
    name: 'Earnest',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_Earnest_v2.zip',
  },
  facetwealth: {
    name: 'Facet Wealth',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_FacetWealth_v2.zip',
  },
  fairway: {
    name: 'Fairway',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_Fairway_v2.zip',
  },
  geico: {
    name: 'GEICO',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_GEICO.zip',
  },
  handrblock: {
    name: 'H&R Block',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_HR-block_V2.zip',
  },
  interactivebrokerslite: {
    name: 'Interactive Brokers Lite',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_InteractiveBrokersLite_v2.zip',
  },
  interactivebrokerspro: {
    name: 'Interactive Brokers Pro',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_InteractiveBrokersPro.zip',
  },
  lenderfi: {
    name: 'LenderFi',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_LenderFI.zip',
  },
  lightstream: {
    name: 'LightStream',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_LightStream_v2.zip',
  },
  marcus: {
    name: 'Marcus by Goldman Sachs',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_MarcusGoldmanSachs_v2.zip',
  },
  marriott: {
    name: 'Marriott Bonvoy™',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_MarriottBonvoy.zip',
  },
  navyfederal: {
    name: 'Navy Federal',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_NavyFederal.zip',
  },
  nbkc: {
    name: 'NBKC',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_NBKC_v3.zip',
  },
  penfedpowered: {
    name: 'Penfed Powered by Purefy',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_PenfedPoweredbyPurefy_v2.zip',
  },
  pnc: {
    name: 'PNC',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_PNC.zip',
  },
  sofiinvesting: {
    name: 'SoFi Investing',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_SoFiInvesting_v2.zip',
  },
  sofiloans: {
    name: 'SoFi Loans',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_SoFiLoans_v3.zip',
  },
  tdameritrade: {
    name: 'TD Ameritrade',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_TDAmeritrade.zip',
  },
  united: {
    name: 'United Explorer',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_United_v2.zip',
  },
  upgrade: {
    name: 'Upgrade',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_Upgrade_v2.zip',
  },
  usbank: {
    name: 'U.S. Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_USBank_v2.zip',
  },
  veteransunited: {
    name: 'Veterans United',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_VeteransUnited_v2.zip',
  },
  wealthfront: {
    name: 'Wealthfront',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_Wealthfront_v2.zip',
  },
  wealthsimple: {
    name: 'Wealthsimple',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_Wealthsimple_v2.zip',
  },
  wellsfargo: {
    name: 'Wells Fargo',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_WellsFargo_v3.zip',
  },
  worldofhyatt: {
    name: 'World of Hyatt',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2020/badges/NW_Awards-2020_WorldofHyatt_v2.zip',
  },
};
